import React, { Component } from 'react';
import { Card, CardBody,
     Col, CardHeader, Badge, Row } from 'reactstrap';

import {connect} from 'react-redux'
import LineComponent from './LineComponent';
import NameComponent from './NameComponent';

class InterpretedImageNode extends Component {

   constructor(props){
       super(props)

   }

  render() {
    return (
        <div 
        style = {{
            width: 300,
            flexDirection:'column',
            display:'flex',
            margin: 5,
            alignItems:'center',
            alignContent:'center',
            marginBottom:20
        }}
        className = {this.props.NoBorder ? "" : "border border-info"}
        >
            <img 
                src = {this.props.Image}
                style = {{
                    width:150,
                    height:150,
                    //marginLeft:5,
                    marginRight:5,
                    marginTop:5
                }}
            />

            <div style = {{marginBottom:5, marginTop:5, width:'100%'}}>
                <NameComponent  text = {this.props.Code}/>
            </div>
            <LineComponent />
            {this.props.Data.map((d, i) =>
            (<div key = {i} style = {{marginBottom:5, width:'100%', flexDirection:'row', display:'flex'}}>
                <Col xs = {5}>
                    <h4 className = "text-dark text-center">
                        {d[0]}
                    </h4>
                </Col>
                <Col xs = {5}>
                    <h4 className = "text-primary text-center">
                        {d[1]}
                    </h4>
                </Col>
            </div>))}
            <div style = {{flexDirection:'column', flex:'display'}}>
                {this.props.ClickTexts.map((t, i) => (
                    <div style = {{cursor:'pointer', marginBottom:20}} key = {i}>
                        <h5 className = "text-center bg-light" 
                            style = {{width:'100%', color:this.props.ClickColors[i]}} 
                            onClick = {() => {
                                this.props.OnClicks[i]()
                            }}
                        >
                            {t}
                        </h5>
                    </div>
                ))}
            </div>
    </div>
)
    
  }
}


function MapStateToProps(state) {
    return {
        default: 0
      }
  }
  
  const MapDispatchToProps = (dispatch) => {
    return {
        default: () => {},
    }
  }
  
export default connect(MapStateToProps, MapDispatchToProps)(InterpretedImageNode)

